import { Box, Grid } from '@mui/material';
import './styles-f1.css';
import merge from 'lodash/merge';
import StepTexts from './StepTexts.js';

const Steps = ({ searchData, setShowModal, activeStep, stepsConfig }) => {
  const { emit = false } = searchData ?? {};
  const isEmit = Boolean(emit);

  const defaults = {
    box1: {
      title: 'Tu Selección',
      subtitle: 'Seleccioná tu producto',
      subtitleMobile: 'Producto',
    },
    box2: {
      title: 'Tus Datos',
      subtitle: 'Ingresá tus datos personales',
      subtitleMobile: 'Datos',
    },
    box3: {
      title: 'Último paso',
      subtitle: 'Finalizar la compra',
      subtitleMobile: 'Pago',
    },
  };

  const cfg = merge({}, defaults, stepsConfig);

  return (
    <Box id="step" sx={{ width: '100%', boxSizing: 'border-box' }}>
      <Grid
        container
        justifyContent="space-between"
        columnSpacing={5}
        sx={{
          width: 'calc(100% + 20px)',
          boxSizing: 'border-box',
          marginLeft: '-40px !important',
          padding: 0,
        }}
      >
        {/* Box 1 */}
        <Grid item xs={isEmit ? 6 : 4}>
          <Box
            id="box1"
            className="box-step active"
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
            onClick={() => setShowModal(true)}
          >
            <StepTexts
              {...cfg.box1}
              wrapperSx={{ ml: { xs: '0px', sm: '25px' } }}
            />
          </Box>
        </Grid>

        {/* Box 2 */}
        <Grid item xs={isEmit ? 6 : 4}>
          <Box
            id="box2-step"
            sx={{
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
            }}
            className={`box2-step ${
              activeStep === 2 ? 'step2active' : 'step2disabled'
            }`}
          >
            <Box
              id="box4"
              className={
                isEmit
                  ? 'boxHijo2'
                  : `boxSon ${activeStep > 2 ? 'disabledSon' : ''} ${
                      activeStep === 2 ? 'activeSonLeft' : ''
                    }`
              }
            />

            <StepTexts {...cfg.box2} />
          </Box>
        </Grid>

        {/* Box 3 */}
        {!isEmit && (
          <Grid item xs={4}>
            <Box
              id="box3"
              sx={{
                cursor: activeStep === 3 ? 'pointer' : '',
                display: 'flex',
                alignItems: 'center',
              }}
              className={`box3 active3 ${activeStep === 3 ? 'active3s' : ''}`}
            >
              <StepTexts {...cfg.box3} />
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default Steps;
